import _ from "lodash";
import { wealthProApi } from '../../redux/api';

const buildLookupText = (opts) => {
    var keys = Object.keys(opts);
    let query = '';

    keys.forEach((k, i) => {
        if (!_.isEmpty(opts[k])) {
            query += i > 0 ? `&${k}=${encodeURI(opts[k])}` : `?${k}=${encodeURI(opts[k])}`;
        }
    });

    return query;
};

const masterAccountApiEndpoints = wealthProApi
.enhanceEndpoints({
    addTagTypes: ["clientsearchmasteraccounts"]
})
.injectEndpoints({
    endpoints: (builder) => ({
        createSetFromClients: builder.mutation({
            query: (body) => ({
                url: `api/clientsearch/master-accounts/client-set`,
                method: 'POST',
                body
            })
        }),
        fetchMasterAccounts: builder.query({
            query: ({ sort, page, pageLimit, ...filters }) => ({
                url: `api/clientsearch/master-accounts`,
                method: 'POST',
                body: {
                    sort,
                    page,
                    limit: pageLimit,
                    ...filters
                }
            }),
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};

                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results)
            },
            forceRefetch({ currentArg, previousArg }) {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
        }),
        fetchMasterAccountsList: builder.query({
            query: ({ sort, page, pageLimit }) => ({
                url: `api/clientsearch/master-accounts/list`,
                method: 'POST',
                body: {
                    sort,
                    page,
                    limit: pageLimit
                }
            }),
            serializeQueryArgs: ({ endpointName }) => {
                return endpointName
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};

                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results)
            },
            forceRefetch({ currentArg, previousArg }) {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
        }),
        getMasterAccountSummary: builder.query({
            query: (masterAccountId) => `api/clientsearch/master-accounts/${masterAccountId}/summary`,
            
        }),
        lookupMasterAccount: builder.query({
            query: (props) => `api/clientsearch/master-accounts/lookup${buildLookupText(props)}`
        })
    })
});

export const {
    useFetchMasterAccountsQuery,
    useFetchMasterAccountsListQuery,
    useLazyFetchMasterAccountsQuery,
    useLazyFetchMasterAccountsListQuery,
    useCreateSetFromClientsMutation,
    useGetMasterAccountSummaryQuery,
    useLookupMasterAccountQuery,
    useLazyLookupMasterAccountQuery
} = masterAccountApiEndpoints;